var hasProp = window.hasProp;
var extend = window.extend;
var extend = function (child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
  },
  hasProp = {}.hasOwnProperty;
Aedu.Notifications.MostRecentNotifications = function (superClass) {
  extend(MostRecentNotifications, superClass);
  function MostRecentNotifications() {
    return MostRecentNotifications.__super__.constructor.apply(this, arguments);
  }
  MostRecentNotifications.prototype.url = $r.api_v0_notification_messages_path({
    subdomain_param: "api"
  });
  MostRecentNotifications.prototype.initialize = function () {
    return this.set('notifications', new Aedu.Notifications.NotificationCollection());
  };
  MostRecentNotifications.prototype.parse = function (response) {
    this.get('notifications').add(response.notifications);
    return _.omit(response, 'notifications');
  };
  MostRecentNotifications.prototype.fetch = function (options) {
    options = options || {};
    if (this.get('earliest_created_at')) {
      _.extend(options, {
        data: {
          created_before: this.get('earliest_created_at')
        }
      });
    }
    return MostRecentNotifications.__super__.fetch.call(this, options);
  };
  return MostRecentNotifications;
}(Backbone.Model);
window.extend = extend;
window.hasProp = hasProp;